import React from 'react';
import { motion } from 'framer-motion';
import { TargetIcon, SwordsIcon, ZapIcon, UsersIcon } from 'lucide-react';
interface GameModeSelectorProps {
  onSelect: (mode: string) => void;
}
export function GameModeSelector({
  onSelect
}: GameModeSelectorProps) {
  const modes = [{
    id: 'stroke',
    title: 'Stroke Play',
    desc: 'Classic scoring. Lowest total wins.',
    icon: TargetIcon,
    color: 'text-brand-gold',
    bg: 'bg-brand-gold/10',
    border: 'border-brand-gold/30',
    badge: '9 holes'
  }, {
    id: 'match',
    title: 'Match Play',
    desc: 'Head to head. Win holes, win the match.',
    icon: SwordsIcon,
    color: 'text-brand-cream-light',
    bg: 'bg-brand-cream/10',
    border: 'border-brand-cream/20',
    badge: '2 players'
  }, {
    id: 'challenge',
    title: 'Challenge Mode',
    desc: 'Complete putting challenges for points.',
    icon: ZapIcon,
    color: 'text-brand-sand',
    bg: 'bg-brand-sand/10',
    border: 'border-brand-sand/30',
    badge: '6 holes • Points'
  }, {
    id: 'bestball',
    title: 'Best Ball',
    desc: 'Team play. Best score from each pair counts per hole.',
    icon: UsersIcon,
    color: 'text-brand-green-light',
    bg: 'bg-brand-green-light/20',
    border: 'border-brand-green-light/40',
    badge: '4 players • Teams'
  }];
  return <div className="flex flex-col h-full p-6 bg-brand-charcoal" data-id="element-123">
      <div className="mt-8 mb-8" data-id="element-124">
        <h2 className="text-3xl font-heading text-brand-cream-light mb-2" data-id="element-125">
          Select Format
        </h2>
        <p className="text-brand-cream/60 font-body text-sm" data-id="element-126">
          Choose how you want to play today.
        </p>
      </div>

      <div className="space-y-4 flex-1 overflow-y-auto pb-8" data-id="element-127">
        {modes.map((mode, i) => <motion.button key={mode.id} initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: i * 0.1
      }} onClick={() => onSelect(mode.id)} className={`w-full text-left p-5 rounded-2xl border ${mode.border} ${mode.bg} backdrop-blur-sm hover:bg-brand-cream/10 transition-all active:scale-[0.98] group relative overflow-hidden`} data-id="element-128">
            <div className="flex items-start space-x-4 relative z-10" data-id="element-129">
              <div className={`p-3 rounded-xl bg-brand-charcoal/50 ${mode.color}`} data-id="element-130">
                <mode.icon className="w-6 h-6" data-id="element-131" />
              </div>
              <div className="flex-1" data-id="element-132">
                <div className="flex items-center justify-between mb-1" data-id="element-133">
                  <h3 className="text-xl font-heading text-brand-cream-light group-hover:text-brand-gold transition-colors" data-id="element-134">
                    {mode.title}
                  </h3>
                  <span className="text-[10px] uppercase tracking-widest font-bold bg-brand-charcoal/50 px-2 py-1 rounded-md text-brand-cream/70" data-id="element-135">
                    {mode.badge}
                  </span>
                </div>
                <p className="text-brand-cream/60 font-body text-xs leading-relaxed pr-4" data-id="element-136">
                  {mode.desc}
                </p>
              </div>
            </div>
            {/* Subtle hover gradient */}
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-brand-cream/5 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 ease-in-out" data-id="element-137" />
          </motion.button>)}
      </div>
    </div>;
}